module.exports = __webpack_public_path__ + "static/media/Lavender Brown 3.513d4559.jpg";